import { memo } from 'react';

import { IconButton, type IconButtonProps } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

export type FileStatusButtonProps = IconButtonProps;

export const FileStatusButton = memo(({ onClick, label, ...restOfProps }: FileStatusButtonProps) => {
  return (
    <Tooltip label={label} side="top" sideOffset={4}>
      <IconButton
        className="ads:text-icon-emphasis ui2026:text-gray-12"
        color="gray"
        label={label}
        onClick={onClick}
        size="small"
        {...restOfProps}
      />
    </Tooltip>
  );
});

FileStatusButton.displayName = 'FileStatusButton';
